import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';

const BotNode = memo(({ data, type }) => {
  const title = data?.label || type;
  const subtitle =
    data?.body ||
    data?.text ||
    (Array.isArray(data?.keywords) ? data.keywords.join(', ') : '') ||
    data?.url ||
    data?.flow_id ||
    data?.to ||
    data?.subject ||
    '';

  return (
    <div className={`bot-node bot-node--${type}`}>
      {type !== 'trigger' && (
        <Handle type="target" position={Position.Left} />
      )}
      <div className="bot-node__type">{type}</div>
      <div>{title}</div>
      {subtitle ? (
        <div style={{ marginTop: 4, color: '#64748b', maxWidth: 180 }} className="admin-cell-clamp">
          {String(subtitle).slice(0, 80)}
        </div>
      ) : null}
      {type !== 'end' && (
        <Handle type="source" position={Position.Right} id="default" />
      )}
      {type === 'condition' && (
        <>
          <Handle type="source" position={Position.Bottom} id="true" style={{ left: '30%' }} />
          <Handle type="source" position={Position.Bottom} id="false" style={{ left: '70%' }} />
        </>
      )}
      {(type === 'list' || type === 'buttons') &&
        (data?.buttons || data?.sections?.[0]?.rows || []).slice(0, 6).map((row, idx) => (
          <Handle
            key={row.id || idx}
            type="source"
            position={Position.Bottom}
            id={`row:${row.id}`}
            style={{ left: `${20 + idx * 12}%` }}
          />
        ))}
    </div>
  );
});

BotNode.displayName = 'BotNode';

export const nodeTypes = {
  trigger: (p) => <BotNode {...p} type="trigger" />,
  text: (p) => <BotNode {...p} type="text" />,
  list: (p) => <BotNode {...p} type="list" />,
  buttons: (p) => <BotNode {...p} type="buttons" />,
  condition: (p) => <BotNode {...p} type="condition" />,
  delay: (p) => <BotNode {...p} type="delay" />,
  media: (p) => <BotNode {...p} type="media" />,
  wa_flow: (p) => <BotNode {...p} type="wa_flow" />,
  http: (p) => <BotNode {...p} type="http" />,
  email: (p) => <BotNode {...p} type="email" />,
  set_var: (p) => <BotNode {...p} type="set_var" />,
  end: (p) => <BotNode {...p} type="end" />,
};

export const PALETTE = [
  { type: 'trigger', label: 'Trigger' },
  { type: 'text', label: 'Text' },
  { type: 'list', label: 'List menu' },
  { type: 'buttons', label: 'Buttons' },
  { type: 'condition', label: 'Condition' },
  { type: 'delay', label: 'Delay' },
  { type: 'media', label: 'Media' },
  { type: 'wa_flow', label: 'WhatsApp Flow' },
  { type: 'http', label: 'HTTP request' },
  { type: 'email', label: 'Send email' },
  { type: 'set_var', label: 'Set variable' },
  { type: 'end', label: 'End' },
];

export const defaultDataForType = (type) => {
  switch (type) {
    case 'trigger':
      return { keywords: ['hi', 'hello'], matchAnyText: false, label: 'On message' };
    case 'text':
      return { body: 'Hello! How can I help?', label: 'Send text' };
    case 'list':
      return {
        label: 'List',
        body: 'Please choose an option',
        button: 'Options',
        sections: [
          {
            title: 'Menu',
            rows: [
              { id: 'OPT_A', title: 'Option A' },
              { id: 'OPT_B', title: 'Option B' },
            ],
          },
        ],
      };
    case 'buttons':
      return {
        label: 'Buttons',
        body: 'Continue?',
        buttons: [
          { id: 'YES', title: 'Yes' },
          { id: 'NO', title: 'No' },
        ],
      };
    case 'condition':
      return { label: 'If', field: 'lastReplyId', equals: 'YES' };
    case 'delay':
      return { label: 'Wait', seconds: 5 };
    case 'media':
      return { label: 'Media', mediaType: 'image', link: '', caption: '' };
    case 'wa_flow':
      return {
        label: 'Flow',
        flow_id: '',
        screen: '',
        flow_cta: 'Open',
        flow_type: '',
        body: 'Please complete the form',
      };
    case 'http':
      return {
        label: 'HTTP',
        method: 'POST',
        url: 'https://example.com/hook',
        saveAs: 'http',
        bodyTemplate: '{}',
      };
    case 'email':
      return {
        label: 'Send email',
        to: '',
        subject: '',
        body: '',
        recipientMode: 'fixed',
        lookupStoreEmail: false,
        useLenshutMailer: true,
      };
    case 'set_var':
      return { label: 'Set var', key: 'choice', value: '' };
    case 'end':
      return { label: 'End', body: 'Thank you!' };
    default:
      return { label: type };
  }
};
